import React from "react";
import axios from "axios";
import * as IoIcons from "react-icons/io";
import Swal from "sweetalert2";
import Cookies from "universal-cookie";
function EliminarSubTitulo(props) {
  const cookies = new Cookies();
  const Eliminar = (e) => {
    e.preventDefault(e);
    axios({
      method: "delete",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/EliminaPerfilAutoevaluacion/" +
        props.Id,
      data: {
        TipoAccion: "Eliminación de registro en equipo autoevaluacion",
        IdUsuario: cookies.get("id"), // o 1262 si es fijo
      },
    })
      .then((Response) => {
        console.log(Response.data);
        Swal.fire({
          title: "eliminado con exito!",
          text: "Eliminado",
          icon: "success",
        });
        window.location.reload("/");
      })
      .catch((error) => {
        console.log(error);
        Swal.fire({
          title: "No se puedo eliminar",
          text: "Intentelo de nuevo",
          icon: "error",
        });
      });
  };
  return (
    <div>
      <button
        variant="contained"
        className="btn btn-danger"
        color="primary"
        onClick={Eliminar}
      >
        {" "}
        <IoIcons.IoIosCloseCircle />{" "}
      </button>
    </div>
  );
}

export default EliminarSubTitulo;
